export default __webpack_public_path__ + "static/media/guide-bg.ebe3fbac.jpg";